import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import config from '@iotv/config';
import { classDerivedDeviceEnabledTypes } from '@iotv/datamodel';
import { getParentEdgeTypeId, getSimpleBranchingQuery, pluralize } from '@iotv/datamodel-core';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Card, CardContent, CardHeader, Tab } from '@mui/material';
import { useEffect, useState } from 'react';
import { getApexInstances } from '../../data/daoFunctions/daoFunctions';
import { isViewOnly } from '../../helpers/access';
import { useTabHandlerStringKeys } from '../../hooks/useTabHandler';
import { AdjacentType, ComparisonType } from '../../types';
import { Listerlizer } from '../factories/Listerlizer/Listerlizer';
import { AutoTab, getRegionViewDefinition } from '../PropertyArea';
import { PartnerDetailCard } from './PartnerDetailCard';
import { PartnerViewDefinition } from './viewDefinitions';
const debug = process.env.REACT_APP_DEBUG && false;
// Get apex region (for regions query)
const regionToRegionQuery = getSimpleBranchingQuery('Region', 'Region', AdjacentType.CHILD);
regionToRegionQuery.addSubQuery(regionToRegionQuery);
export const PartnerView = (props) => {
    const { viewObject: viewContext } = props;
    const { userFunctions, transactionFunctions, contextCustomer, userGroupRoles, userSelectedGroup, applicationData, allowedActions } = props;
    const contextPartner = props.viewObject.matchedPrimary;
    const viewOnly = isViewOnly(userSelectedGroup);
    const [apexRegions, setApexRegions] = useState(undefined);
    useEffect(() => {
        getApexInstances('Region').then((region_res) => {
            debug && console.log('PartnerView', 'apex regions res', region_res);
            if (region_res.data)
                setApexRegions(region_res.data);
        });
    }, []);
    const tabDefs = [
        {
            label: 'Details',
            value: 'Details',
            component: contextPartner && contextCustomer ? (_jsx(PartnerDetailCard, { userFunctions,
                transactionFunctions,
                viewDefinition: PartnerViewDefinition,
                mostProximateCustomer: contextCustomer,
                matchedPrimary: contextPartner,
                hide: isViewOnly(userSelectedGroup),
                //editMode: isAdminRole(userSelectedGroup) ? ComponentMode.EDIT : ComponentMode.VIEW,
                showContextSubCard: !viewOnly,
                allowedActions })) : (_jsx(_Fragment, {})),
        },
        ...(viewOnly
            ? []
            : [
                {
                    label: 'User Groups',
                    value: 'User Groups',
                    type: 'Group',
                    constraints: [{ key: 'supportedType', predicate: ComparisonType.EQUALS, value: 'User' }],
                    edgeTypeId: getParentEdgeTypeId('Group', 'Partner'),
                    direction: AdjacentType.CHILD,
                },
                {
                    label: 'Regions',
                    value: 'Regions',
                    component: (_jsx(Listerlizer, { viewObject: {
                            matchedPrimary: contextPartner,
                            matchedRelatedByPk: [],
                            matchedRelatedBySk: [],
                        }, adjacentFilter: {
                            adjacentType: AdjacentType.PARENT,
                            objectType: 'Region',
                        }, 
                        //initMode={ComponentMode.EDIT}
                        contextObject: contextCustomer, linkableItemsBranchingQueryDefinition: regionToRegionQuery, searchRootObjects: apexRegions, userFunctions: userFunctions, transactionFunctions: transactionFunctions, viewDefinition: getRegionViewDefinition(), applicationData: applicationData })),
                },
            ]),
        ...classDerivedDeviceEnabledTypes.map((det) => ({
            label: `Shared ` +
                (config.app?.webUI?.groupedObjectTypes?.[det]?.collectionName
                    ? pluralize(config.app?.webUI?.groupedObjectTypes?.[det].collectionName)
                    : `${det} Groups`),
            value: `${det} groups`,
            type: 'Group',
            constraints: [{ key: 'supportedType', predicate: ComparisonType.EQUALS, value: `${det}` }],
            edgeTypeId: getParentEdgeTypeId('Group', 'Partner'),
            direction: AdjacentType.CHILD,
        })),
    ];
    const tabKeyMap = Object.fromEntries(tabDefs.map((t) => [t.value, t]));
    const { state: [[value, setValue]], handlers: { handleTabChange }, } = useTabHandlerStringKeys(tabKeyMap);
    const typesToViewDefs = {};
    return (_jsxs(Card, { children: [_jsx(CardHeader, { title: contextPartner?.name ?? 'Partner View' }), _jsx(CardContent, { sx: { padding: 0, '&:last-child': { padding: 2 } }, children: _jsxs(TabContext, { value: value, children: [_jsx(TabList, { value, onChange: handleTabChange, children: tabDefs.map((t) => (_jsx(Tab, { label: t.label, value: t.value, sx: { textTransform: 'none' } }, t.value))) }), tabDefs.map((t) => {
                            const tabContent = contextPartner && (_jsx(AutoTab, { tabDef: t,
                                mostProximateCustomer: contextCustomer,
                                contextCustomer,
                                contextObject: contextPartner,
                                viewObject: viewContext,
                                userFunctions,
                                transactionFunctions,
                                viewDefinitionIn: typesToViewDefs[t.type ?? ''],
                                newObjectDefinition: typesToViewDefs[t.type ?? ''] }));
                            return (_jsx(TabPanel, { value: t.value, sx: { padding: 0, paddingBlockStart: 1 }, children: tabContent }, t.value));
                        })] }) })] }));
};
